/* LUNA — apenas comportamentos novos.
   Não duplica variantes, galeria nem carrinho: isso continua com o JS do tema. */
(function () {
  'use strict';

  function digits(v) { return (v || '').replace(/\D/g, '').slice(0, 8); }

  /* ---------------------------------------------------------
     Área de entrega por CEP
     O CEP vira coordenada (AwesomeAPI, com BrasilAPI de reserva) e é
     comparado com círculos de entrega (lat, lng, raio em km).
     Dentro de uma área liberada e fora das bloqueadas → WhatsApp + Lead.
     Fora → mensagem de "não entregamos". Se as consultas falharem,
     segue para o WhatsApp para não perder o cliente.
     --------------------------------------------------------- */

  function parseZones(text) {
    return (text || '').split(/\n|;/).map(function (line) {
      var n = line.split(',').map(function (x) { return parseFloat(x); });
      if (n.length < 3 || n.some(isNaN)) return null;
      return { lat: n[0], lng: n[1], km: n[2] };
    }).filter(Boolean);
  }

  function distanceKm(a, b) {
    var R = 6371, rad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * rad, dLng = (b.lng - a.lng) * rad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function insideAny(point, zones) {
    return zones.some(function (z) { return distanceKm(point, z) <= z.km; });
  }

  function fetchJson(url, ms) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms);
    return fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) {
      clearTimeout(timer);
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  var cepCache = {};
  function lookupCep(cep) {
    if (cepCache[cep]) return cepCache[cep];
    cepCache[cep] = fetchJson('https://cep.awesomeapi.com.br/json/' + cep, 4000).then(function (j) {
      var lat = parseFloat(j.lat), lng = parseFloat(j.lng);
      if (isNaN(lat) || isNaN(lng)) throw new Error('sem coordenadas');
      return { lat: lat, lng: lng, city: j.city, uf: j.state, district: j.district };
    }).catch(function () {
      return fetchJson('https://brasilapi.com.br/api/cep/v2/' + cep, 4000).then(function (j) {
        var c = j.location && j.location.coordinates || {};
        var lat = parseFloat(c.latitude), lng = parseFloat(c.longitude);
        return { lat: lat, lng: lng, city: j.city, uf: j.state, district: j.neighborhood, noCoords: isNaN(lat) || isNaN(lng) };
      });
    }).catch(function () {
      return { failed: true };
    });
    return cepCache[cep];
  }

  function initCep(scope) {
    scope.querySelectorAll('[data-luna-cep]').forEach(function (box) {
      if (box.dataset.lunaReady === 'true') return;
      box.dataset.lunaReady = 'true';

      var input  = box.querySelector('.luna-cep__input');
      var button = box.querySelector('[data-luna-cep-submit]');
      var error  = box.querySelector('[data-luna-cep-error]');
      var out    = box.querySelector('[data-luna-cep-out]');
      if (!input || !button) return;

      var allow = parseZones(box.getAttribute('data-zones-allow'));
      var block = parseZones(box.getAttribute('data-zones-block'));
      var zonesOn = allow.length > 0;
      var results = {}; // cep -> resultado já resolvido

      // CEPs da Grande São Paulo vão de 01000-000 a 09999-999.
      // Fora dessa faixa já sabemos que não entregamos, sem consultar nada.
      function inGreaterSP(cep) {
        var n = parseInt(cep.slice(0, 5), 10);
        return n >= 1000 && n <= 9999;
      }

      function verdict(r, cep) {
        if (!zonesOn) return 'ok';
        if (cep && !inGreaterSP(cep)) return 'out';
        if (!r || r.failed || r.noCoords) return 'ok'; // não deu para verificar: não perde o cliente
        var p = { lat: r.lat, lng: r.lng };
        if (insideAny(p, block)) return 'out';
        return insideAny(p, allow) ? 'ok' : 'out';
      }

      function prefetch(cep) {
        if (!zonesOn || results[cep]) return;
        if (!inGreaterSP(cep)) { lookupCep(cep).then(function (r) { results[cep] = r; }); return; }
        lookupCep(cep).then(function (r) { results[cep] = r; });
      }

      function whatsappUrl(cep) {
        var parts = [box.getAttribute('data-message') || ''];
        var ctx = box.getAttribute('data-context');
        if (ctx) parts.push(ctx);
        parts.push('CEP: ' + cep.slice(0, 5) + '-' + cep.slice(5));
        return 'https://wa.me/' + box.getAttribute('data-phone') + '?text=' + encodeURIComponent(parts.join('\n\n'));
      }

      function showOut(cep, r) {
        if (!out) return;
        var place = r && r.city ? (r.district ? r.district + ', ' : '') + r.city + (r.uf ? ' – ' + r.uf : '') : 'CEP ' + cep.slice(0, 5) + '-' + cep.slice(5);
        var msg = (box.getAttribute('data-zone-msg') || 'Ainda não entregamos em {local}.').replace('{local}', place);
        out.querySelector('[data-luna-cep-out-text]').textContent = msg;
        out.hidden = false;
      }

      function go(cep, tab) {
        if (typeof fireLead === 'function' && box.getAttribute('data-luna-lead')) fireLead(box);
        var url = whatsappUrl(cep);
        if (tab) { try { tab.opener = null; } catch (e) {} tab.location.href = url; }
        else if (!window.open(url, '_blank', 'noopener')) { /* noopener sempre retorna null */ }
      }

      function setLoading(on) {
        button.classList.toggle('is-loading', on);
        button.disabled = on;
      }

      function submit() {
        var cep = digits(input.value);
        if (out) out.hidden = true;
        if (cep.length !== 8) {
          if (error) error.hidden = false;
          input.focus();
          return;
        }
        if (error) error.hidden = true;

        // Fora da faixa da Grande SP: recusa na hora (o nome da cidade entra se já tiver chegado)
        if (zonesOn && !inGreaterSP(cep)) {
          showOut(cep, results[cep]);
          return;
        }

        // Resultado já pronto (consultado enquanto o cliente digitava): decide na hora
        if (!zonesOn || results[cep]) {
          if (verdict(results[cep], cep) === 'ok') go(cep, null);
          else showOut(cep, results[cep]);
          return;
        }

        // Ainda consultando: abre a aba já (dentro do clique, para não ser bloqueada)
        // e decide quando a resposta chegar
        var tab = window.open('', '_blank');
        setLoading(true);
        lookupCep(cep).then(function (r) {
          results[cep] = r;
          setLoading(false);
          if (verdict(r, cep) === 'ok') {
            go(cep, tab);
          } else {
            if (tab) tab.close();
            showOut(cep, r);
          }
        });
      }

      input.addEventListener('input', function () {
        var v = digits(input.value);
        input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
        if (out) out.hidden = true;
        if (v.length === 8) {
          if (error) error.hidden = true;
          prefetch(v);
        }
      });

      // O campo vive dentro do formulário de compra: Enter não pode submeter
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        submit();
      });

      button.addEventListener('click', submit);
    });
  }


  /* Barra fixa de compra (celular): aparece quando o botão principal sai da tela */
  function initSticky() {
    var bar = document.querySelector('[data-luna-sticky]:not([data-luna-ready])');
    var main = document.getElementById('botao-whatsapp');
    if (!bar || !main) return;
    // Editor da Shopify recriou a seção: remove a barra antiga
    document.querySelectorAll('[data-luna-sticky][data-luna-ready]').forEach(function (old) { old.remove(); });
    bar.dataset.lunaReady = 'true';

    // Fora de qualquer container com transform/sticky, senão o "fixed" quebra
    document.body.appendChild(bar);

    var btn = bar.querySelector('[data-luna-sticky-buy]');
    btn.addEventListener('click', function () { window.__lunaLeadSource = 'barra_fixa_celular'; main.click(); });

    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('luna-sticky-on', on);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // Só aparece depois que o cliente já passou pelo botão principal
        setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(main);
    } else {
      setVisible(true);
    }
  }


  /* Variante sem estoque: botão de compra (e barra fixa) mostram ESGOTADO e não abrem o WhatsApp */
  function initSoldout() {
    if (window.__lunaSoldoutBound) return;
    window.__lunaSoldoutBound = true;

    function setSoldout(on) {
      document.querySelectorAll('[data-luna-buy], [data-luna-sticky-buy]').forEach(function (btn) {
        btn.classList.toggle('is-soldout', on);
        if (on) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
        var label = btn.querySelector('[data-luna-buy-label]');
        var text = btn.getAttribute(on ? 'data-soldout-label' : 'data-label');
        if (label && text) label.textContent = text;
      });
    }

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      setSoldout(!variant || !variant.available);
    });

    // Fase de captura: roda antes do script do tema que abre o WhatsApp
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-luna-buy].is-soldout, [data-luna-sticky-buy].is-soldout');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  }

  function initReviews(scope) {
    scope.querySelectorAll('[data-luna-reviews]').forEach(function (box) {
      if (box.dataset.lunaReady === 'true') return;
      box.dataset.lunaReady = 'true';

      var track = box.querySelector('[data-luna-track]');
      var prev  = box.querySelector('[data-luna-prev]');
      var next  = box.querySelector('[data-luna-next]');
      if (!track) return;

      function step() {
        var c = track.querySelector('.luna-review');
        return c ? c.offsetWidth + 16 : 300;
      }
      function maxScroll() {
        return track.scrollWidth - track.clientWidth - 2;
      }
      function sync() {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll();
      }

      if (prev) prev.addEventListener('click', function () { pause(); track.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function () { pause(); track.scrollLeft += step(); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      // Deslize automático para a esquerda, voltando ao início ao terminar
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (box.getAttribute('data-autoplay') !== 'true' || reduced) return;
      if (track.querySelectorAll('.luna-review').length < 2) return;

      var interval = parseInt(box.getAttribute('data-autoplay-interval'), 10) || 4000;
      var timer;

      function advance() {
        if (track.scrollLeft >= maxScroll()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        }
      }
      function play() { stop(); timer = setInterval(advance, interval); }
      function stop() { clearInterval(timer); }
      function pause() { stop(); setTimeout(play, interval * 2); }

      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', play);
      track.addEventListener('touchstart', pause, { passive: true });
      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : play();
      });

      play();
    });
  }

  var timers = new WeakMap();

  function initAnnouncement(scope) {
    scope.querySelectorAll('[data-luna-announcement]').forEach(function (bar) {
      if (bar.dataset.lunaReady === 'true') return;
      bar.dataset.lunaReady = 'true';

      var track = bar.querySelector('[data-luna-ann-track]');
      if (!track) return;

      var items = track.querySelectorAll('.luna-announcement__item');
      if (items.length < 2) return;

      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
      var current  = 0;

      function show(n) {
        current = n;
        track.style.transform = 'translateX(' + (-current * 100) + '%)';
        items.forEach(function (item, i) {
          if (i === current) {
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
        });
      }

      function play() {
        stop();
        timers.set(bar, setInterval(function () {
          show((current + 1) % items.length);
        }, interval));
      }
      function stop() { clearInterval(timers.get(bar)); }

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', play);
      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : play();
      });

      show(0);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
    });
  }


  /* ---------------------------------------------------------
     Preço: recalcula PIX, valor cheio e parcela ao trocar de variante
     --------------------------------------------------------- */

  function brl(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function brlNoCents(cents) {
    return Math.round(cents / 100).toLocaleString('pt-BR', {
      style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0
    });
  }

  function initPrice() {
    if (window.__lunaPriceBound) return;
    window.__lunaPriceBound = true;

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      document.querySelectorAll('[data-luna-price]').forEach(function (box) {
        var parcels = parseInt(box.getAttribute('data-parcels'), 10) || 12;
        var tax     = parseInt(box.getAttribute('data-tax'), 10) || 0; // juros em pontos-base

        var cash    = box.querySelector('[data-luna-price-cash]');
        var full    = box.querySelector('[data-luna-price-full]');
        var parcel  = box.querySelector('[data-luna-price-parcel]');
        var compare = box.querySelector('[data-luna-price-compare]');
        var compareVal = box.querySelector('[data-luna-price-compare-value]');

        // variant.price já vem em centavos
        var totalCents  = Math.round(variant.price * (10000 + tax) / 10000);
        var parcelCents = Math.round(totalCents / parcels);

        if (cash)   cash.textContent   = brl(variant.price);
        if (full)   full.textContent   = brlNoCents(totalCents); // total com juros, sem centavos
        if (parcel) parcel.textContent = brl(parcelCents);

        // Preço promocional: mostra "de X por" só quando há compare_at_price maior
        if (compare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            if (compareVal) compareVal.textContent = brl(variant.compare_at_price);
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }

        // Selo de desconto (-X%) e "Você economiza", em terracota
        var onSale  = variant.compare_at_price && variant.compare_at_price > variant.price;
        var off     = box.querySelector('[data-luna-price-off]');
        var save    = box.querySelector('[data-luna-price-save]');
        var saveVal = box.querySelector('[data-luna-price-save-value]');
        if (off) {
          off.hidden = !onSale;
          if (onSale) off.textContent = '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
        }
        if (save) {
          save.hidden = !onSale;
          if (onSale && saveVal) saveVal.textContent = brl(variant.compare_at_price - variant.price);
        }
      });
    });
  }


  /* ---------------------------------------------------------
     Evento de conversão: Lead
     Dispara ao clicar no botão de WhatsApp e ao enviar o CEP.
     O clique abre wa.me em nova aba, então a página atual não
     é descarregada e o pixel tem tempo de registrar.
     --------------------------------------------------------- */

  function fireLead(el) {
    if (typeof window.fbq !== 'function') return;

    // Mesmo formato do Lead que o tema já dispara no botão de compra,
    // no mesmo Pixel, para os dois eventos ficarem consistentes no Meta.
    window.fbq('trackSingle', '1408658623512930', 'Lead', {
      content_name: el.getAttribute('data-lead-name') || document.title,
      content_category: 'WhatsApp',
      source: 'calcular_frete_cep'
    });
  }

  function initLead(scope) {
    // O botão de WhatsApp é um link <a href="wa.me/...">; o tema já dispara
    // Lead nele por um listener global. Não religamos aqui para não duplicar.
    // O CEP abre o WhatsApp por JS (não é link), então o Lead dele é disparado
    // dentro do próprio submit do CEP, abaixo.
    void scope;
  }


  /* ---------------------------------------------------------
     Barreiras contra cópia casual das fotos.
     Importante: isto NÃO impede o download de verdade — a imagem
     já está no dispositivo de quem vê a página. Serve para tirar
     os caminhos fáceis (botão direito, arrastar, segurar no
     celular) do visitante comum.
     --------------------------------------------------------- */

  function isProtectedImage(el) {
    if (!el || !el.tagName) return false;
    if (el.tagName === 'IMG') return true;
    // Alguns temas usam fundo em <div>; cobrimos a galeria do produto
    return !!el.closest('.product-gallery__carousel-item, .drift-zoom-pane');
  }

  function initImageProtection() {
    if (!window.lunaProtectImages) return;
    if (window.__lunaProtectBound) return;
    window.__lunaProtectBound = true;

    document.documentElement.classList.add('luna-protect');

    // Botão direito sobre a imagem
    document.addEventListener('contextmenu', function (event) {
      if (isProtectedImage(event.target)) event.preventDefault();
    });

    // Arrastar a imagem para a área de trabalho / outra aba
    document.addEventListener('dragstart', function (event) {
      if (isProtectedImage(event.target)) event.preventDefault();
    });
  }


  /* ---------------------------------------------------------
     Busca instantânea: a lupa abre um painel com campo de busca
     e resultados que aparecem enquanto o cliente digita.
     Usa a API nativa da Shopify (/search/suggest.json) — rápida
     e sem recarregar a página.
     --------------------------------------------------------- */

  function initSearch() {
    if (window.__lunaSearchBound) return;
    var panel = document.querySelector('[data-luna-search]');
    if (!panel) return;
    window.__lunaSearchBound = true;

    var input   = panel.querySelector('[data-luna-search-input]');
    var results = panel.querySelector('[data-luna-search-results]');
    var wrap    = panel.querySelector('[data-luna-search-results-wrap]');
    var loading = panel.querySelector('[data-luna-search-loading]');
    var empty   = panel.querySelector('[data-luna-search-empty]');
    var allLink = panel.querySelector('[data-luna-search-all]');

    var money = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';

    function brl(cents) {
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: money });
    }

    function openPanel() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.querySelectorAll('[data-luna-search-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
      // Foca após o início do deslize (evita rolagem estranha no iOS)
      requestAnimationFrame(function () { input.focus(); });
    }

    function closePanel() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.querySelectorAll('[data-luna-search-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    function show(el, on) { if (el) el.hidden = !on; }

    function render(items, term) {
      results.innerHTML = '';
      items.forEach(function (p) {
        var li = document.createElement('li');
        li.className = 'luna-search__item';

        var a = document.createElement('a');
        a.className = 'luna-search__link';
        a.href = p.url;

        var img = p.image ? '<img class="luna-search__thumb" src="' + p.image +
                  '" alt="" width="56" height="56" loading="lazy">'
                  : '<span class="luna-search__thumb luna-search__thumb--empty"></span>';

        var price = (typeof p.price === 'number') ? '<span class="luna-search__price">' + brl(p.price) + '</span>' : '';

        a.innerHTML = img +
          '<span class="luna-search__meta">' +
            '<span class="luna-search__name">' + p.title + '</span>' +
            price +
          '</span>';

        li.appendChild(a);
        results.appendChild(li);
      });

      if (allLink) {
        allLink.href = '/search?q=' + encodeURIComponent(term) + '&type=product';
        show(allLink, true);
      }
      show(wrap, true);
    }

    // Debounce: só busca ~180ms após parar de digitar, para não disparar a
    // cada tecla e manter a resposta fluida.
    var timer = null;
    var controller = null;

    function query(term) {
      // Cancela a busca anterior ainda em andamento
      if (controller) { try { controller.abort(); } catch (e) {} }
      controller = ('AbortController' in window) ? new AbortController() : null;

      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
                '&resources[type]=product&resources[limit]=8' +
                '&resources[options][unavailable_products]=last';

      show(wrap, true);
      show(loading, true);
      show(empty, false);

      fetch(url, { signal: controller ? controller.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          show(loading, false);
          var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
          var items = prods.map(function (p) {
            return {
              title: p.title,
              url: p.url,
              image: (p.featured_image && p.featured_image.url) || p.image || '',
              price: p.price ? Math.round(parseFloat(p.price) * 100) : null
            };
          });
          if (!items.length) {
            results.innerHTML = '';
            show(wrap, true);
            show(empty, true);
            show(allLink, false);
            return;
          }
          render(items, term);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return; // busca substituída, ignora
          show(loading, false);
          show(empty, true);
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();

      if (timer) clearTimeout(timer);

      // Começa a mostrar produtos já a partir da 1ª letra digitada
      if (term.length < 1) {
        results.innerHTML = '';
        show(loading, false);
        show(empty, false);
        show(allLink, false);
        show(wrap, false);
        return;
      }
      timer = setTimeout(function () { query(term); }, 150);
    });

    // Enter vai para a página de busca completa com o termo
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var term = input.value.trim();
        if (term) window.location.href = '/search?q=' + encodeURIComponent(term) + '&type=product';
      }
      if (e.key === 'Escape') closePanel();
    });

    document.querySelectorAll('[data-luna-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openPanel(); });
    });
    panel.querySelectorAll('[data-luna-search-close]').forEach(function (btn) {
      btn.addEventListener('click', closePanel);
    });

    // Clicar em qualquer lugar fora da gaveta fecha (deslizando de volta)
    document.addEventListener('click', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (e.target.closest('[data-luna-search]')) return;      // dentro da busca: ignora
      if (e.target.closest('[data-luna-search-open]')) return; // é a lupa: já tratada
      closePanel();
    });
  }

  function init(scope) {
    var root = scope || document;
    initCep(root);
    initReviews(root);
    initAnnouncement(root);
    initPrice();
    initLead(root);
    initImageProtection();
    initSearch();
    initSticky();
    initSoldout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Editor da Shopify recria a seção no DOM
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-luna-announcement]').forEach(function (bar) {
      clearInterval(timers.get(bar));
    });
  });
})();
